import React from 'react'
import './Service.scss'

export default function Service() {
  return (
    <>
       <div className='container-fluid' id="service-c-f">
            <div className='container' id="service-c">
                <h3 className=''>My Education</h3>
                {/* <p>Share your services or product offerings here. Present them as simple headers that can lead out to their pages where you can expound on them further. You can also use this space for other purposes where the information is best presented as mere teasers to other individualized pages.</p> */}
                {/* <p>Here I am providing infromation about my schooling and collage study.</p> */}
                <div className='row py-4'>
                    <div className='col-lg-3 col-md-4 col-sm-12 my-3'>
                        <div className='col p-0' id="service-item-wrap">
                            <div className='col-12 p-0' id="ser-item">
                                <img src="https://i.pinimg.com/originals/96/d7/6b/96d76b7bf659f52ed7abc3fc0dfa3a4a.jpg" alt=''/>
                            </div>
                            <div className='col-12' id="ser-itema">
                                {/* <h5>Research & Planning</h5> */}
                                <h5 className=''>High School (10th)</h5>
                                <p className='p-0 m-0'>MP Board</p>
                                <p className='p-0 m-0'>Year - 2017-18</p>
                                <p className='p-0 m-0'>Result - 88%</p>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-3 col-md-4 col-sm-12 my-3'>
                        <div className='col p-0' id="service-item-wrap">
                            <div className='col-12 p-0' id="ser-item">
                                <img src="https://i.pinimg.com/originals/84/0c/df/840cdf93f552d8e08e3d7faf0d75c484.jpg" alt=''/>
                            </div>
                            <div className='col-12' id="ser-itema">
                                {/* <h5>Content</h5> */}
                                <h5 className=''>Intermediate (12th)</h5>
                                <p className='p-0 m-0'>MP Board</p>
                                <p className='p-0 m-0'>Year - 2019-20</p>
                                <p className='p-0 m-0'>Result - 80.4%</p>
                                {/* <h5>Software Development</h5>
                                <a href="/"><button className='btn d-block mx-auto bg-info'>Learn More</button></a> */}
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-3 col-md-4 col-sm-12 my-3'>
                        <div className='col p-0' id="service-item-wrap">
                            <div className='col-12 p-0' id="ser-item">
                                <img src="https://i.pinimg.com/originals/dc/f4/f5/dcf4f5dc292ed6edcd0091ea530f0320.jpg" alt=''/>
                            </div>
                            <div className='col-12' id="ser-itema">
                                {/* <h5>Analytics</h5> */}
                                <h5 className=''>B.Voc in Software Development</h5>
                                <p className='p-0 m-0'>IGNTU</p>
                                <p className='p-0 m-0'>Year - 2020-23</p>
                                <p className='p-0 m-0'>Result - 9.98CGPA</p>
                                {/* <h5>Android Development</h5>
                                <a href="/"><button className='btn d-block mx-auto bg-info'>Learn More</button></a> */}
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-3 col-md-6 col-sm-12 my-3'>
                        <div className='col p-0' id="service-item-wrap">
                            <div className='col-12 p-0' id="ser-item">
                                <img src="https://i.pinimg.com/originals/f1/f0/1c/f1f01c498008dba5dcc0407260302828.jpg" alt=''/>
                            </div>
                            <div className='col-12' id="ser-itema">
                                {/* <h5>Analytics</h5> */}
                                <h5 className=''>MCA</h5>
                                <p className='p-0 m-0'>IGNTU</p>
                                <p className='p-0 m-0'>Year - 2023-25</p>
                                <p className='p-0 m-0'>Result - </p>
                                {/* <h5>Android Development</h5>
                                <a href="/"><button className='btn d-block mx-auto bg-info'>Learn More</button></a> */}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col px-0 py-5">
                    <h3 className=''>Certificates</h3>
                    <p className=''>These are all the Certifications I've done</p>
                    <div className="row py-4 ">
                        <div className="col-lg-4 col-md-6 col-sm-12 mx-auto mt-5">
                            <div className='col p-0' id="service-item-wrap">
                                <div className='col-12 p-0' id="ser-item">
                                    <img src="https://www.hrkatha.com/wp-content/uploads/2020/06/Internshala.png" alt=''/>
                                </div>
                                <div className='col-12' id="ser-itema">
                                    {/* <h5>Research & Planning</h5> */}
                                    <h5 className=''>Full Stack Web Development</h5>
                                    <p className='p-0 m-0'>Internsala</p>
                                    <p className='p-0 m-0'>Experience - 6 month</p>
                                    {/* <p className='p-0 m-0'>Result - 88%</p> */}
                                    <div className="col px-0 mt-3">
                                        <a href="https://internshala.com/"><button className='btn d-block mx-auto bg-info'>Visit Here</button></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 mx-auto mt-5">
                            <div className='col p-0' id="service-item-wrap">
                                <div className='col-12 p-0' id="ser-item">
                                    <img src="https://i.pinimg.com/originals/7d/89/0a/7d890aaa5aa84a684ffccfcbfbce817a.png" alt=''/>
                                </div>
                                <div className='col-12' id="ser-itema">
                                    {/* <h5>Research & Planning</h5> */}
                                    <h5 className=''>Full Stack Web Development</h5>
                                    <p className='p-0 m-0'>Beanget Academy </p>
                                    <p className='p-0 m-0'>Location- Bhopal MP</p>
                                    <p className='p-0 m-0'>Experience - 6 month</p>
                                    {/* <p className='p-0 m-0'>Result - 88%</p> */}
                                    <div className="col px-0 mt-3">
                                        <a href="https://academy.beangates.com/"><button className='btn d-block mx-auto bg-info'>Visit Here</button></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 mx-auto mt-5">
                            <div className='col p-0' id="service-item-wrap">
                                <div className='col-12 p-0' id="ser-item">
                                    <img src="https://www.online-tech-tips.com/wp-content/uploads/2023/04/snapchat-1.jpeg" alt=''/>
                                </div>
                                <div className='col-12' id="ser-itema">
                                    {/* <h5>Research & Planning</h5> */}
                                    <h5 className=''>Lens Development</h5>
                                    <p className='p-0 m-0'>Snapchat</p>
                                    <p className='p-0 m-0'>2 days bootcamp</p>
                                    <div className="col px-0 mt-3">
                                        <a href="https://www.snapchat.com/"><button className='btn d-block mx-auto bg-info'>Visit Here</button></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
       </div>
    </>
    )
}
